import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c525d6e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c525d6e')) {
      api.createRecord('6c525d6e', component.options)
    } else {
      api.reload('6c525d6e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6c525d6e", function () {
      api.rerender('6c525d6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChatContent/Header/index.vue"
export default component.exports